export function findLineIntersection(m1, y1, m2, y2) {
  if (m1 === m2) {
    return null
  }
  const x = (y2 - y1) / (m1 - m2)
  return [x, m1 * x + y1]
}
